import OpeningBalanceActionTypes from './opening-balance.types';
/* ******************************* GET OPENING BALANCE START ********************************/
export const getopeningbalanceDetailsStart = (addData: any) => ({
	type: OpeningBalanceActionTypes.GET_OPENING_BALANCE_DETAILS_START,
	payload: addData,
});
export const getopeningbalanceDetailsSuccess = (addData: any) => ({
	type: OpeningBalanceActionTypes.GET_OPENING_BALANCE_DETAILS_SUCCESS,
	payload: addData,
});
export const getopeningbalanceDetailsFailure = (addData: any) => ({
	type: OpeningBalanceActionTypes.GET_OPENING_BALANCE_DETAILS_FAILURE,
	payload: addData,
});
export const getopeningbalanceDetailsResponceReset = () => ({
	type: OpeningBalanceActionTypes.GET_OPENING_BALANCE_DETAILS_RESPONSE_RESET,
});
export const getopeningbalanceDetailsResponceChanged = () => ({
	type: OpeningBalanceActionTypes.GET_OPENING_BALANCE_DETAILS_RESPONSE_CHANGED,
});
/* ******************************* GET OPENING BALANCE END ********************************/

/* ******************************* UPDATE OPENING BALANCE START ********************************/
export const updateopeningbalanceDetailsStart = (addData: any) => ({
	type: OpeningBalanceActionTypes.UPDATE_OPENING_BALANCE_DETAILS_START,
	payload: addData,
});
export const updateopeningbalanceDetailsSuccess = (addData: any) => ({
	type: OpeningBalanceActionTypes.UPDATE_OPENING_BALANCE_DETAILS_SUCCESS,
	payload: addData,
});
export const updateopeningbalanceDetailsFailure = (addData: any) => ({
	type: OpeningBalanceActionTypes.UPDATE_OPENING_BALANCE_DETAILS_FAILURE,
	payload: addData,
});
export const updateopeningbalanceDetailsResponceReset = () => ({
	type: OpeningBalanceActionTypes.UPDATE_OPENING_BALANCE_DETAILS_RESPONSE_RESET,
});
export const updateopeningbalanceDetailsResponceChanged = () => ({
	type: OpeningBalanceActionTypes.UPDATE_OPENING_BALANCE_DETAILS_RESPONSE_CHANGED,
});
/* ******************************* UPDATE OPENING BALANCE END ******************************/
